/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';
import urlJoin from 'proper-url-join';

import { Template, TemplateMetadata } from '../../../../ts/templates';
import { getServerBaseUri } from '../../util/url';

const buildTemplateEndpoint = (templateFileName: string) =>
  urlJoin(getServerBaseUri(), `assets/actions/templates`, templateFileName);

const buildMetadataEndpoint = (metadataFileName: string) =>
  urlJoin(getServerBaseUri(), 'assets/metadata/templates', metadataFileName);

/*
 * Get template JSON from templateFileName
 */
export const getTemplate = async (
  templateFileName: string
): Promise<Template> => {
  const url = buildTemplateEndpoint(templateFileName);
  const response = await axios.get(url);
  return response.data;
};

/**
 * List all template metadata to fill in TemplateCatalog and TemplatePreviewModal
 */
export const getTemplateMetadata = async (
  metadataFileName: string
): Promise<TemplateMetadata[]> => {
  const url = buildMetadataEndpoint(metadataFileName);
  const response = await axios.get(url);
  return response.data?.templateMetadata.map((metadata: TemplateMetadata) => ({
    ...metadata,
    catalogImg: urlJoin(getServerBaseUri(), metadata.catalogImg),
    previewImg: urlJoin(getServerBaseUri(), metadata.previewImg)
  }));
};
